exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-border-card[data-v-12f746c2] {\n  border: 0px !important;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  margin: 0;\n}\n[data-v-12f746c2] .md-card .md-card-actions {\n  border-top: none;\n}\n", ""]);

// exports
